import ConfiguracionTalentosPlantel from "./ConfiguracionTalentosPlantel";

const ConfiguracionesAdicionalesTab = ({ plantelId }) => {
  return (
    <div className="container-fluid py-4">
      <ConfiguracionTalentosPlantel plantelId={plantelId} />
    </div>
  );
};

export default ConfiguracionesAdicionalesTab;
